export const entity = {
  _id: "66c8189a5fb810015d64d11e",
  ticketTypes: [],
  surveyConfig: {
    _id: "66c8189b5fb810015d64d15c",
    isSurveyEnabled: true,
    entity: "66c8189a5fb810015d64d11e",
    __v: 0,
    surveyBtnStyle: "emoji",
    surveyMsg: "Please choose the option that best reflects your current mood:",
  },
  chainIds: [1, 42161, 56],
  ecosystemsChainIds: {
    evm: [1, 137, 42161, 56, 10],
    solana: ["solana", "eclipse"],
  },
  tokenChainIds: [],
  company: {
    name: "",
    logo: "https://storage.googleapis.com/metadesk-demo/logo/demoJustin1/Frame846-1706190243.png",
    website: "",
  },
  theme: {
    customColor: {
      primary: "#FFFFFF",
      text: "#383538",
      border: "#D6D6D6",
      button: "#61d5ff",
      hover: "#E6E6E6",
      background: "#F1F1F1",
      buttonText: "#F8F8F8",
    },
    name: "custom",
  },
  modules: {
    service: true,
    marketing: true,
    analytics: true,
    CDP: true,
    notification: true,
    kol: true,
  },
  nftInfo: [],
  smartContractInfo: [],
  fetchGeneralTx: true,
  tokenProfile: {
    tokens: [],
  },
  privacyPolicyCheckedRequired: true,
  signatureSignInDisabled: false,
  standard: false,
  tracking: {
    apiKey: "",
    created: "",
  },
  hasLegacy: false,
  ecosystems: { evm: true, solana: true },
  serviceModule: {
    _id: "66c81a645fb810015d680fa9",
    discordWebhook: {
      enabled: true,
      connected: false,
    },
    widgetSupport: {
      isCustomizationAllowed: true,
      enabled: true,
    },
    aiSupport: {
      magicWand: {
        enabled: true,
        connected: true,
      },
      enabled: true,
      connected: true,
    },
    github: {
      connected: false,
      enabled: false,
      url: "https://github.com/apps/metacrm-issues-demo/installations/select_target?state=demojustin3",
    },
    discord: {
      connected: true,
      enabled: true,
      serverId: "1077605035153817741",
      serverName: "0xJFox's server",
      updatedAt: "2024-11-27T16:32:49.735Z",
      url: "https://discord.com/api/oauth2/authorize?client_id=1115922372558590022&permissions=534992251984&redirect_uri=https://beta.metacrm.inc/connectDiscord&response_type=code&scope=bot+applications.commands",
    },
    slack: {
      connected: false,
      enabled: true,
      url: "https://slack.com/oauth/v2/authorize?client_id=2773801149877.7509588218407&scope=channels:read,chat:write,channels:join&user_scope=",
    },
    mailchimp: {
      connected: false,
      enabled: true,
    },
    webSupport: {
      connected: true,
      enabled: true,
    },
    entity: "66c8189a5fb810015d64d11e",
    __v: 0,
    telegram: {
      connected: true,
      enabled: true,
      updatedAt: "2024-10-18T05:42:00.428Z",
    },
    jira: {
      enabled: true,
      connected: true,
      updatedAt: "2024-11-27T16:32:49.735Z",
    },
    linear: {
      enabled: true,
      connected: true,
      updatedAt: "2024-11-27T16:32:49.735Z",
    },
    discordAnalytics: {
      connected: true,
      enabled: true,
      updatedAt: "2024-11-27T16:32:49.735Z",
    },
    telegramAnalytics: {
      connected: true,
      enabled: true,
      updatedAt: "2024-11-27T16:32:49.735Z",
    },
  },
  kolModule: {
    xCampaign: {
      enabled: true,
    },
  },
  notificationModule: {
    _id: "66c81a645fb810015d680fae",
    notification: {
      connected: true,
      enabled: true,
    },
    xmtp: {
      enabled: true,
      address: "0x9Ec346743B1db8729B590c27df61Df796C0E3254",
      connected: true,
      updatedAt: "2024-11-22T16:32:49.735Z",
    },
    websiteOptIn: {
      enabled: true,
      latestVersion: "0.0.1",
      version: "0.0.0",
      connected: false,
      connecting: false,
      updatedAt: "2025-03-11T10:40:54.035Z",
    },
    entity: "66c8189a5fb810015d64d11e",
    __v: 0,
  },
  analyticsModule: {
    _id: "67360d1f40b8c6fe3394b823",
    entity: "66c8189a5fb810015d64d11e",
    __v: 0,
    attribution: {
      enabled: true,
      connecting: false,
      connected: true,
      referral: {
        enabled: true,
        connected: true,
      },
      multipleObjectives: false,
      url: "https://attribution-demo.netlify.app/",
      version: "1.1.1",
      latestVersion: "1.1.1",
      updatedAt: "2024-11-27T16:32:49.735Z",
    },
    createdAt: "2024-11-14T14:45:51.290Z",
    updatedAt: "2024-11-14T14:45:51.290Z",
  },
  demoSite: true,
  widgetModule: {
    enabled: true,
    multiDomain: false,
    latestVersion: "2.1.2",
    version: "2.1.2",
    connected: true,
    connecting: false,
  },
};

export const tags = [
  {
    _id: "654265fee31a7181bb7e57b8",
    entity: "66c8189a5fb810015d64d11e",
    value: "Loyal",
    color: "#7CD4FD",
    type: "user",
    __v: 0,
  },
  {
    _id: "65a626d81c255bb47d031d17",
    entity: "66c8189a5fb810015d64d11e",
    type: "user",
    value: "Flippers",
    color: "#D6BBFB",
    __v: 0,
  },
  {
    _id: "65a626f21c255bb47d031d4f",
    entity: "66c8189a5fb810015d64d11e",
    type: "user",
    value: "VIP",
    color: "#FDA19B",
    __v: 0,
  },
  {
    _id: "65d56d821b65afaff91db8bb",
    entity: "66c8189a5fb810015d64d11e",
    type: "user",
    value: "Holder",
    color: "#FEC84B",
    __v: 0,
  },
];
export const ticketTags = [
  {
    _id: "654265fee31a7181bb7e57b8",
    entity: "66c8189a5fb810015d64d11e",
    value: "Loyal",
    color: "#7CD4FD",
    type: "user",
    __v: 0,
  },
  {
    _id: "65a626d81c255bb47d031d17",
    entity: "66c8189a5fb810015d64d11e",
    type: "user",
    value: "Flippers",
    color: "#D6BBFB",
    __v: 0,
  },
  {
    _id: "65a626f21c255bb47d031d4f",
    entity: "66c8189a5fb810015d64d11e",
    type: "user",
    value: "VIP",
    color: "#FDA19B",
    __v: 0,
  },
  {
    _id: "65d56d821b65afaff91db8bb",
    entity: "66c8189a5fb810015d64d11e",
    type: "user",
    value: "Holder",
    color: "#FEC84B",
    __v: 0,
  },
];
export const onchainData = {
  ecosystem: "evm",
  enabled: true,
  chainIds: [1, 137, 42161, 10, 5000, 8217],
  portfolio: {
    tokens: [
      {
        decimals: 18,
        _id: "6835677f439230f1cb44180e",
        address: "0x9e3319636e2126e3c0bc9e3134AEC5e1508A46c7",
        chainId: 1,
        name: "Universa",
        icon: "https://storage.googleapis.com/metacrm-assets/token/1/0x9e3319636e2126e3c0bc9e3134AEC5e1508A46c7.png",
      },
    ],
    nfts: [],
  },
};
export const teamMembers = [
  {
    readonly: false,
    _id: "6538932a2bd756be9bc2ce51",
    address: "0x175fd9b68973c4b2a5f371909FB624b0aEb88Cc5",
    entity: "653893232bd756be9bc2c452",
    __v: 0,
    created: "2023-11-06T08:46:10.705Z",
    name: "MetaCRM TEST",
    role: {
      _id: "65c2082a8527f55d9f013bdf",
      name: "Admin",
    },
    latestLogin: "2025-03-28T10:40:25.422Z",
  },
  {
    readonly: false,
    _id: "6538932b2bd756be9bc2ce8a",
    address: "0x0578857574cE12174351b17925AfaFDC86051057",
    entity: "653893232bd756be9bc2c452",
    __v: 0,
    created: "2023-11-06T08:46:10.853Z",
    name: "MetaCRM TEST-2",
    role: {
      _id: "65c2082a8527f55d9f013bdf",
      name: "Admin",
    },
    latestLogin: "2024-06-27T06:55:50.432Z",
  },
];
export const userInfo = {
  address: "0x123",
  role: "Admin",
  team: {
    _id: "653f686b097cc75118534048",
    address: "0x123",
    name: "MetaCRM-DEMO",
    entity: "653893232bd756be9bc2c452",
    role: {
      _id: "65c2082a8527f55d9f013bdf",
      entity: "653893232bd756be9bc2c452",
      name: "Admin",
      __v: 3,
      accessibleTickets: [
        "6538932b2bd756be9bc2ceac",
        "6538932b2bd756be9bc2ceb9",
        "65a5fd8d1c255bb47d02f96b",
        "66863085591030e9213b4119",
        "6687b337591030e9213ee045",
        "67283ce070b1636424c7816c",
        "67d925d86d616b21f4c56b74",
        "67ec12041a59910df3cad2cd",
      ],
      isAdmin: true,
      permissions: [
        {
          _id: "666fe0e6645362e1c6c51dfa",
          name: "tickets",
          value: "edit",
        },
        {
          _id: "666fe0e6645362e1c6c51dfe",
          name: "notifications",
          value: "edit",
        },
        {
          _id: "666fe0e6645362e1c6c51e00",
          name: "notificationPerformance",
          value: "edit",
        },
        {
          _id: "666fe0e6645362e1c6c51e01",
          name: "customerList",
          value: "edit",
        },
        {
          _id: "666fe0e6645362e1c6c51e02",
          name: "segmentation",
          value: "edit",
        },
        {
          _id: "666fe0e6645362e1c6c51e07",
          name: "profileCompany",
          value: "edit",
        },
        {
          _id: "666fe0e6645362e1c6c51e08",
          name: "profileUser",
          value: "edit",
        },
        {
          _id: "666fe0e6645362e1c6c51e0a",
          name: "integration",
          value: "edit",
        },
        {
          _id: "666fe0e6645362e1c6c51e0b",
          name: "macros",
          value: "edit",
        },
        {
          _id: "666fe0e6645362e1c6c51e0f",
          name: "billing",
          value: "none",
        },
        {
          _id: "66e27cf23f21e5ed586c945d",
          name: "customerReport",
          value: "edit",
        },
        {
          _id: "672da31940b8c6fe33270704",
          name: "ticketReport",
          value: "edit",
        },
        {
          _id: "672da31940b8c6fe33270705",
          name: "xCampaigns",
          value: "edit",
        },
        {
          _id: "672da31940b8c6fe33270707",
          name: "referral",
          value: "edit",
        },
        {
          _id: "672da31940b8c6fe33270706",
          name: "webTraffic",
          value: "edit",
        },
        {
          _id: "672da31940b8c6fe3327070b",
          name: "attributionLink",
          value: "edit",
        },
        {
          _id: "672da31940b8c6fe3327070f",
          name: "aiManagement",
          value: "edit",
        },
        {
          _id: "672da31940b8c6fe3327070e",
          name: "ticketSettings",
          value: "edit",
        },
        {
          _id: "672da31940b8c6fe33270710",
          name: "onchainData",
          value: "edit",
        },
        {
          _id: "672da31940b8c6fe33270711",
          name: "team",
          value: "edit",
        },
        {
          _id: "6752a64eec54f17a87da2987",
          name: "communityAnalysis",
          value: "edit",
        },
      ],
    },
    created: "2023-10-30T08:25:15.738Z",
    __v: 0,
    latestLogin: "2025-06-04T09:38:48.780Z",
  },
};

export const widgetConfig = [
  {
    _id: "66cde0f0dd2a0abbc09a58aa",
    position: ["bottom", "right"],
    entity: "653893232bd756be9bc2c452",
    name: "Test Widget",
    apiKey: "jpfmm95q0f",
    ticketTypes: [
      {
        _id: "6538932b2bd756be9bc2ceac",
        assignee: null,
        ticketType: "6538932b2bd756be9bc2ceac",
      },
      {
        _id: "6538932b2bd756be9bc2ceb9",
        assignee: null,
        ticketType: "6538932b2bd756be9bc2ceb9",
      },
      {
        _id: "65a5fd8d1c255bb47d02f96b",
        assignee: null,
        ticketType: "65a5fd8d1c255bb47d02f96b",
      },
      {
        _id: "66863085591030e9213b4119",
        assignee: null,
        ticketType: "66863085591030e9213b4119",
      },
      {
        _id: "6687b337591030e9213ee045",
        assignee: null,
        ticketType: "6687b337591030e9213ee045",
      },
      {
        _id: "67283ce070b1636424c7816c",
        assignee: null,
        ticketType: "67283ce070b1636424c7816c",
      },
      {
        _id: "67ec12041a59910df3cad2cd",
        assignee: "67ec12041a59910df3cad2c5",
        ticketType: "67ec12041a59910df3cad2cd",
      },
    ],
    connecting: false,
    connected: true,
    __v: 1,
    jsVersion: "3.4.0",
    autoAssign: false,
    displacement: "none",
    icon: "https://storage.googleapis.com/metacrm-assets/logo/ic_widget07-1700205700.svg",
    iconSize: "normal",
    colorTheme: {
      primaryColor: "#c193ff",
      mode: "dark",
      backgroundColor: "#EAF0FA",
      hoverColor: "#555555",
      textHoverColor: "#555555",
      cardColor: "#FFFFFF",
      cardHoverColor: "#F1F6FF",
    },
    logo: "https://storage.googleapis.com/metadesk-dev/chat/0xAB68C24C573B1771aC7d4551A3D3897B4F8b1173/截圖2024-11-08下午5.48.43-ed85e9e5-a2fb-44d2-b72e-43b6298b4433-1731482472.png",
    allowGuestTicket: true,
    url: "https://dev.metaform.xyz",
    emailAskingMessage:
      "Before getting started, please leave your email so we can assist you better.",
    guestModeEmailAskingMessage:
      "Please provide your email if you’d like to be notified when your question is answered 😊 (or feel free to ask your question directly).",
    openingMessage: "Hi! How can I assist you today?",
    created: "2024-08-27T14:21:36.438Z",
    isCustomizationAllowed: true,
  },
];
